import Pubnub from 'pubnub';
import { getTrackingTokenFromLocalStorage } from 'helpers/browser';
import { PublicCallback } from 'globals/types';
import { getStore } from 'core_main/store';

export class PubNubInstance {
  instance: Pubnub | undefined;

  constructor() {
    const store = getStore();

    const { publishKey, subscribeKey } = store.settings.sharedPubNubKeySet;
    const { customerId } = store;
    const trackingToken = getTrackingTokenFromLocalStorage();

    if (trackingToken !== null && customerId) {
      this.instance = new Pubnub({
        uuid: customerId,
        authKey: trackingToken,
        subscribeKey,
        publishKey,
        restore: true,
        ssl: true,
      });
    }
  }

  listChannels = (
    listChannelsParameters: Pubnub.ListChannelsParameters,
    cb?: PublicCallback,
  ) => {
    if (!this.instance) return undefined;

    return this.instance?.channelGroups.listChannels(
      listChannelsParameters,
      (status, response) => {
        const { error } = status;
        if (cb && error === false) {
          cb(response);
        }
      },
    );
  };

  fetchMessages = (
    fetchMessagesParameters: Pubnub.FetchMessagesParameters,
    cb?: PublicCallback,
  ) => {
    if (!this.instance) return undefined;

    return this.instance?.fetchMessages(
      fetchMessagesParameters,
      (status, response) => {
        const { error } = status;
        if (cb && error === false) {
          cb(response);
        }
      },
    );
  };

  messageCounts = (
    messageCountsParameters: Pubnub.MessageCountsParameters,
    cb?: PublicCallback,
  ) => {
    if (!this.instance) return undefined;

    return this.instance?.messageCounts(
      messageCountsParameters,
      (status, response) => {
        const { error } = status;
        if (cb && error === false) {
          cb(response);
        }
      },
    );
  };
}

let PubNubMetaInstance: PubNubInstance | undefined;
let PubNubConversationInstance: PubNubInstance | undefined;
export const getMetaPubNub = (): PubNubInstance | undefined => {
  if (getTrackingTokenFromLocalStorage() === null) return undefined;
  if (!PubNubMetaInstance) {
    PubNubMetaInstance = new PubNubInstance();
  }
  return PubNubMetaInstance;
};

export const getConversationPubNub = (): PubNubInstance | undefined => {
  if (getTrackingTokenFromLocalStorage() === null) return undefined;
  if (!PubNubConversationInstance) {
    PubNubConversationInstance = new PubNubInstance();
  }
  return PubNubConversationInstance;
};

export const clearPubNub = () => {
  if (PubNubMetaInstance) {
    PubNubMetaInstance.instance?.unsubscribeAll();
    PubNubMetaInstance = undefined;
  }
  if (PubNubConversationInstance) {
    PubNubConversationInstance.instance?.unsubscribeAll();
    PubNubConversationInstance = undefined;
  }
};

export const stopPubNub = () => {
  if (PubNubMetaInstance) {
    PubNubMetaInstance.instance?.stop();
    PubNubMetaInstance = undefined;
  }
  if (PubNubConversationInstance) {
    PubNubConversationInstance.instance?.stop();
    PubNubConversationInstance = undefined;
  }
};

export const disconnect = () => {
  // TODO remove the typecast to any when the @types/pubnub types are updated to a version that has disconnect()
  if (PubNubMetaInstance) {
    (PubNubMetaInstance.instance as any).disconnect();
  }
  if (PubNubConversationInstance) {
    (PubNubConversationInstance.instance as any).disconnect();
  }
};

export const reconnect = () => {
  if (PubNubMetaInstance) {
    PubNubMetaInstance.instance?.reconnect();
  }
  if (PubNubConversationInstance) {
    PubNubConversationInstance.instance?.reconnect();
  }
};
